var map = {
	"./andarbahar_en.png": "tXBZ",
	"./andarbahar_th.png": "G5XN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oOYO";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa ^\.\/andarbahar_.*\.png$
// module id = oOYO
// module chunks = 1